// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HNArWWz9IFRPDF {
  width: 321px;
  margin-bottom: var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-100, 3px);
}
.HNArWWz9IFRPDF .gOcSlZhdMfNqoP {
  height: max-content;
  padding: var(--ds-space-150, 10px) var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
  background-color: var(--ds-surface, #ffffff);
}
.HNArWWz9IFRPDF .gOcSlZhdMfNqoP .q4PkTSMr8eP5pJ,
.HNArWWz9IFRPDF .gOcSlZhdMfNqoP .UEPeC5IMPPuHbs {
  display: inline;
  margin-right: var(--ds-space-075, 5px);
  margin-left: var(--ds-space-150, 10px);
  font-weight: var(--ds-font-weight-bold, bold);
  vertical-align: text-bottom;
}
.HNArWWz9IFRPDF .gOcSlZhdMfNqoP .q4PkTSMr8eP5pJ {
  border-bottom: 1px dashed var(--ds-text-subtlest, #626f86);
  cursor: pointer;
}
.HNArWWz9IFRPDF .GnTRyExjd1pTVP {
  display: flex;
  justify-content: space-between;
  padding: var(--ds-space-150, 10px) var(--ds-space-200, 16px);
  column-gap: var(--ds-space-050, 4px);
  border: 1px solid var(--ds-border, #091e4224);
}
@media only screen and (max-width: 450px) {
  .HNArWWz9IFRPDF {
    width: 265px;
  }
}
`, ""]);
// Exports
export var card = `HNArWWz9IFRPDF`;
export var feature = `gOcSlZhdMfNqoP`;
export var featureName = `q4PkTSMr8eP5pJ`;
export var featureNameNoTooltip = `UEPeC5IMPPuHbs`;
export var plan = `GnTRyExjd1pTVP`;
export default ___CSS_LOADER_EXPORT___;
